import { IonButton, IonSpinner, useIonToast } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateTemplateStatus } from "../../../store/templateDetail";
import { updateTemplateData } from "../../../store/templateDetail/actions/updateTemplateData";
import { selectUpdateTemplateStatus } from "../../../store/templateDetail/selectors/selectUpdateTemplateStatus";

export const SubmitTemplateChangesButton = () => {
  const dispatch = useDispatch();
  const [presentToast, hideToast] = useIonToast();
  const updateTemplateStatus = useSelector(selectUpdateTemplateStatus);

  const handleUpdateTemplate = async () => {
    try {
      presentToast({
        message: `Guardando cambios...`,
        color: "primary",
      });
      const {
        payload: { success },
      }: any = await dispatch(updateTemplateData());

      if (!success) {
        throw new Error("No se guardaron los cambios.");
      }
      await hideToast();
      presentToast({
        message: `Se guardaron los cambios.`,
        color: "success",
        duration: 2000,
      });
      dispatch(setUpdateTemplateStatus(""));
    } catch (error) {
      await hideToast();
      presentToast({
        message: "Ocurrió un problema guardando los cambios.",
        color: "danger",
        duration: 2000,
      });
    }
  };

  return (
    <IonButton onClick={handleUpdateTemplate} disabled={updateTemplateStatus === "pending"}>
      {updateTemplateStatus === "pending" ? (
        <>
          <IonSpinner /> Guardando...
        </>
      ) : (
        "GUARDAR"
      )}
    </IonButton>
  );
};
